import { t } from 'i18next';

const SECTION_TYPES = {
  ORIGINAL: 'OT',
  STANDARD: 'ST',
};

const PLATFORMS = {
  IOS: 'ios',
  ANDROID: 'android',
};

const STORY_TYPES = {
  STANDARD: {
    type: 'STAN',
    label: t('표준'),
  },
  ORIGINAL: {
    type: 'ORGI',
    label: t('오리지널'),
  },
};

const STORY_STATUS = {
  ACTIVE: 'AT',
  INACTIVE: 'IAT',
};

const STUDIO_TYPE = {
  MOBILE: 'M',
  PC: 'PC',
};

const STORY_PUBLICATION = {
  PROGRESS: 'PRG',
  FINISH: 'FIN',
};

const STORY_SALE_TYPES = {
  FREE: 'FREE',
  WAITFREE: 'WF',
  AD_WAITFREE: 'WFAD',
  PAID: 'PAID',
};

const PURCHASE_TYPES = {
  WAITFREE: 'WAITFREE',
  SHOW_AD: 'AD',
  RENTAL: 'RENTAL',
  POSSESSION: 'POSSESSION',
  REMOVE_AD: 'AD_FREE',
  PREVIEW: 'PREVIEW',
};

const getEpisodeStatuses = () => ({
  PRIVATE: {
    type: 'PRIV',
    label: t('비공개'),
  },
  REVIEW: {
    type: 'REV',
    label: t('검수중'),
  },
  REJECT: {
    type: 'REJ',
    label: t('반려'),
  },
  PUBLIC: {
    type: 'PUBL',
    label: t('공개'),
  },
  BOOKED_PUBLIC: {
    type: 'PUBB',
    label: t('예약'),
  },
});

const EPISODE_STATUSES = {
  PRIVATE: {
    type: 'PRIV',
    label: t('비공개'),
  },
  REVIEW: {
    type: 'REV',
    label: t('검수중'),
  },
  REJECT: {
    type: 'REJ',
    label: t('반려'),
  },
  PUBLIC: {
    type: 'PUBL',
    label: t('공개'),
  },
  BOOKED_PUBLIC: {
    type: 'PUBB',
    label: t('예약'),
  },
};

const getMarketItemTypes = () => ({
  ITEM: {
    type: 'ITEM',
    label: t('아이템'),
  },
  // ETC: {
  //   type: 'ETC',
  //   label: t('기타'),
  // },
  USER_PICTURE: {
    type: 'SU_P',
    label: t('프로필'),
  },
  PROFILE_BACKGROUND: {
    type: 'SUP_BG',
    label: t('배경'),
  },
  NICKNAME: {
    type: 'SU_N',
    label: t('닉네임'),
  },
  COMMENT: {
    type: 'SC_CD',
    label: t('댓글'),
  },
  PROFILE_BUTTON: {
    type: 'SUP_BTN',
    label: t('팔로우 버튼'),
  },
});

const USER_MESSAGE_TYPES = {
  UNREGISTER_USER: 'close_user',
  REVIEW: 'low_review',
  REQUEST_CATEGORY: 'req_category',
  APP_REVIEW: 'app_review',
  STORY_AD_REVIEW: 'story_ad_review',
};

const AD_STATUSES = {
  LOADING: 0,
  SUCCESS: 1,
  FAILED: 2,
};

const TAB_INDEXES = {
  HOME: 0,
  SEARCH: 1,
  LIBRARY: 2,
  STUDIO: 3,
};

const TAG_STATUS = {};

const PAYMENT_VENDORS = {
  STANDARD: 'S',
  APPLE: 'A',
};

const PAYMENT_TYPES = {
  COIN: 'C',
  BALLOON: 'PT',
};

const AD_TYPES = {
  REWARD: 'reward',
  INTERSTITIAL: 'interstitial',
  FBINTERSTITIAL: 'fbinterstitial',
  INTERSTITIAL_BACKFILL: 'interstitial_backfill',
  CHEER_REWARD: 'cheer_reward',
  STORY_AD_FULL: 'story_ad_full',
};

const AD_MEDIATION_TYPES = {
  MOPUB: 'mopub',
  ADX: 'adx',
};

const REMOTE_CONFIG_KEYS = {
  SHOW_AD_TAP_COUNT: 'SHOW_AD_TAP_COUNT',
  EPISODE_AD_ORDER: 'EPISODE_AD_ORDER',
  CERT_POPUP_DURATION: 'CERT_POPUP_DURATION',
};

const COLOR = {
  TEAL: '#20a2ae',
  BLACK: '#1d2127',
  WHITE: '#ffffff',
  LIGHT_GRAY: '#f2f2f2',
};

const BALLOON_TYPES = {
  BRONZE: 'bronze',
  SILVER: 'silver',
  GOLD: 'gold',
  DONATION: 'platinum',
};

const CHEER_TYPES = {
  AD: 'AD',
  ADF: 'ADF',
};

const USER_SETTINGS = {
  REPLY: 'new_reply_push_status',
  EPISODE: 'new_episode_push_status',
  FOLLOWING: 'following_update_push_status',
};

const STORY_AD_TYPES = {
  LIST: 'LIST',
  FULL: 'FULL',
};

const NOTIFICATION_TYPES = {
  ENABLE: 'enable',
  PARTIAL_ENABLE: 'partial_enable',
  DISABLE: 'disable',
};

const getRestrictionStatus = () => ({
  NORMAL: {
    value: 'normal',
    label: t('정상'),
  },
  CAU: {
    value: 'cau',
    label: t('주의'),
  },
  WARN_1: {
    value: 'warn1',
    label: t('1차 경고'),
  },
  WARN_2: {
    value: 'warn2',
    label: t('2차 경고'),
  },
  WARN_3: {
    value: 'warn3',
    label: t('3차 경고'),
  },
  WARN_4: {
    value: 'warn4',
    label: t('4차 경고'),
  },
  EXC: {
    value: 'exc',
    label: t('정지'),
  },
});

const RESTRICTION_STATUS = {
  NORMAL: {
    value: 'normal',
    label: t('정상'),
  },
  CAU: {
    value: 'cau',
    label: t('주의'),
  },
  WARN_1: {
    value: 'warn1',
    label: t('1차 경고'),
  },
  WARN_2: {
    value: 'warn2',
    label: t('2차 경고'),
  },
  WARN_3: {
    value: 'warn3',
    label: t('3차 경고'),
  },
  WARN_4: {
    value: 'warn4',
    label: t('4차 경고'),
  },
  EXC: {
    value: 'exc',
    label: t('정지'),
  },
};

const STORY_AD_EVENT_CHECK_TYPES = {
  EASY_ENTRY: 'easy_entry',
};

const VIEWER_OPTIONS = {
  FONT_SIZE: 'fontSize',
  AUTO_PLAY_SPEED: 'autoPlaySpeed',
  THEME: 'theme',
};

const THEME_GROUPS = {
  tap_novel: [
    {
      name: 'white',
      backgroundColor: '#ffffff',
      textColor: '#1c1c1c',
    },
    {
      name: 'light_gray',
      backgroundColor: '#A0A0A0',
      textColor: '#29292E',
    },
    {
      name: 'ivory',
      backgroundColor: '#e2ddce',
      textColor: '#333333',
    },
    {
      name: 'gray',
      backgroundColor: '#484744',
      textColor: '#CACACA',
    },
    {
      name: 'black',
      backgroundColor: '#000000',
      textColor: '#CACACA',
    },
  ],
};

const THEMES = {
  TAP_NOVEL: 'tap_novel',
  IKNOW: 'iknow',
  IKNOW_STANDARD: 'iknow_standard',
};

const VOUCHER_TYPES = {
  AB_F_S: 'AB_F_S',
  ABP_F_P: 'ABP_F_P',
  ABP_F_R: 'ABP_F_R',
  DBP_F_D: 'DBP_F_D',
  DBP_F_SA: 'DBP_F_SA',
  DBN_F_SA: 'DBN_F_SA',
  ALL: 'ALL',
  ALL_STORY_ADS: 'ALL_STORY_ADS',
  ALL_DONATION: 'ALL_DONATION',
  ALL_REWARD: 'ALL_REWARD',
  ALL_PAYMENT: 'ALL_PAYMENT',
};

const VOUCHER_RECOMMENDATION_TYPES = {
  PAYMENT: 'PAYMENT',
  REWARD: 'REWARD',
  STORY_ADS: 'STORY_ADS',
  DONATION: 'DONATION',
};

const SECTION_VIEW_TYPES = {
  DEFAULT: 'DF',
  STORY_HORIZONTAL: 'STY_HL_V1',
  STORY_HORIZONTAL_BACKGROUND: 'STY_HLB_V1',
  STORY_VERTICAL: 'STY_VL_V1',
  STORY_RANK: 'STY_RANK_V1',
  STORY_RANK2: 'STY_RANK_V2',
};

export default {
  SECTION_TYPES,
  PLATFORMS,
  STORY_TYPES,
  STORY_STATUS,
  STUDIO_TYPE,
  STORY_SALE_TYPES,
  STORY_PUBLICATION,
  PURCHASE_TYPES,
  getEpisodeStatuses,
  EPISODE_STATUSES,
  getMarketItemTypes,
  USER_MESSAGE_TYPES,
  AD_STATUSES,
  TAB_INDEXES,
  PAYMENT_VENDORS,
  PAYMENT_TYPES,
  AD_TYPES,
  AD_MEDIATION_TYPES,
  REMOTE_CONFIG_KEYS,
  COLOR,
  BALLOON_TYPES,
  CHEER_TYPES,
  USER_SETTINGS,
  STORY_AD_TYPES,
  NOTIFICATION_TYPES,
  getRestrictionStatus,
  RESTRICTION_STATUS,
  STORY_AD_EVENT_CHECK_TYPES,
  VIEWER_OPTIONS,
  THEME_GROUPS,
  THEMES,
  VOUCHER_TYPES,
  VOUCHER_RECOMMENDATION_TYPES,
  SECTION_VIEW_TYPES,
};



// WEBPACK FOOTER //
// ./src/app/utils/constants.js